export default {
  perPerson: ['PER_PERSON'],
  perQuantity: ['PER_PERSON', 'PER_CAR', 'PER_BOTTLE']
};
